import React from "react";
import { Drawer } from "@mui/material";
import DrawerHeader from "../../shared/helpers/DrawerHeader.js";
import DrawerFooterContainerSmall from "../../shared/helpers/DrawerFooterContainerSmall.js";
import ButtonFilled from "../../shared/helpers/ButtonFilled.js";
import ModalInfoCard from "../../shared/helpers/ModalInfoCard.js";
import ModalUserStatusCard from "../../shared/helpers/ModalUserStatusCard.js";
import ModalAvailabilityCard from "../../shared/helpers/ModalAvailabilityCard.js";
import {
  formatDateReadable,
  formatTimestampDateReadable,
} from "../../utilities/helpers.js";
import {
  CalendarToday,
  AccessTime,
  ChatBubbleOutline,
  Sync,
  Send,
  CheckCircle,
  PersonOutline
} from '@mui/icons-material';

const AvailabilityApprovedDrawer = (props) => {
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    props.setDrawerOpen(open);
  };


  return (
    <Drawer anchor="right" open={props.isDrawerOpen} onClose={toggleDrawer(false)}>
      <div className="w-[450px] h-screen bg-white relative">
        <div className="max-h-screen overflow-auto">
          <DrawerHeader
            title="Availability Request History"
            onClose={toggleDrawer(false)}
          />
          <div className="px-6 py-5">
            {/* User Status Section */}
            <div className="mb-6">
              <ModalUserStatusCard
                status={props.requestInfo.status.toLowerCase()}
                name={props.requestInfo.name}
              />
            </div>

            {/* Info Cards */}
            <div className="w-full">
              <div className="mb-4">
                <ModalInfoCard
                  icon={CalendarToday}
                  title="Day"
                  value={props.requestInfo.day}
                />
              </div>

              <div className="mb-4">
                <ModalAvailabilityCard
                  title="Current Availability"
                  availability={props.requestInfo.currentAvailability}
                  availability2={props.requestInfo.currentAvailability2}
                  preferences={props.requestInfo.currentPreferences}
                  icon={AccessTime}
                />
              </div>

              <div className="mb-4">
                <ModalAvailabilityCard
                  title="Requested Availability"
                  availability={props.requestInfo.requestedAvailability}
                  availability2={props.requestInfo.requestedAvailability2}
                  preferences={props.requestInfo.requestedPreferences}
                  icon={Sync}
                />
              </div>

              <div className="mb-4">
                <ModalInfoCard
                  icon={CalendarToday}
                  title="Effective Date"
                  value={formatDateReadable(props.requestInfo.inEffect)}
                />
              </div>

              {props.requestInfo.note && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={ChatBubbleOutline}
                    title="Employee Note"
                    value={props.requestInfo.note}
                  />
                </div>
              )}

              {props.requestInfo.managerNote && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={ChatBubbleOutline}
                    title="Manager Note"
                    value={props.requestInfo.managerNote}
                  />
                </div>
              )}

              {props.requestInfo.dateSubmitted && props.requestInfo.dateResponded && (
                <div className="flex flex-row items-start space-x-4">
                  <div className="flex-1">
                    <ModalInfoCard
                      icon={Send}
                      title="Date Submitted"
                      value={formatTimestampDateReadable(props.requestInfo.dateSubmitted, props.storeTimezone)}
                    />
                  </div>
                  <div className="flex-1">
                    <ModalInfoCard
                      icon={CheckCircle}
                      title="Date Responded"
                      value={formatTimestampDateReadable(props.requestInfo.dateResponded, props.storeTimezone)}
                    />
                  </div>
                </div>
              )}

              {props.requestInfo.actedBy && (
                <div className="mt-4">
                  <ModalInfoCard
                    icon={PersonOutline}
                    title="Responded By"
                    value={props.requestInfo.actedBy}
                  />
                </div>
              )}
            </div>
            <div className="h-[200px]"></div>
          </div>
        </div>
        <DrawerFooterContainerSmall>
          <div className="w-full">
            <ButtonFilled
              text="Close"
              onClick={toggleDrawer(false)}
            />
          </div>
        </DrawerFooterContainerSmall>
      </div>
    </Drawer>
  );
};

export default AvailabilityApprovedDrawer;
